<template>
  <div>
    <div class="headbt">
      <span class="zjt" @click="fh"><img src="../../assets/img/zjt.png" ></span>任务详情&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>


    <div class="rwbt">
      <div class="bwbt_1">
          {{this.plainwz.title}}
      </div>


      <div class="xxjs">
          <div class="xxjs_sm">请先阅读量表说明，按照要求开始答题。</div>
           <div class="xxjs_xq">{{this.plainwz.explain}}</div>
            <div v-if="dtstate == 0">
                <div class="dtan" @click="tz('/user/datia/'+taskId)" v-if="plainwz.kszt =='进行中'">我知道了，开始答题</div>
                <div class="dtan wks" v-else>{{plainwz.kszt}}</div>
            </div>
            <div v-else>
                <div class="dtan wks wksda">该测试题已经答过了，请选择其他测试题</div>
                <div class="qrfh">返回({{ms}})</div>
            </div>
      </div>


    </div>


    <div class="bkx">

    </div>

		<div class="footer ">
		  <div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/base/index')">
			  <div class="dibumenu">
          	 <img src="../../assets/img/home.png" >
			</div>
			  <div class="xmtitle ">
			  	首页
			  </div>
		  </div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3">
				<div class="dibumenu">
          	<!-- <img src="../../static/wd.png" > -->
             <img src="../../assets/img/cp_xz.png" >
				</div>
				<div class="xmtitle xmtitle_active">
					测评任务
				</div>
			</div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/wdcp')">
				<div class="dibumenu">
				 	 <img src="../../assets/img/wdcp.png" >
				</div>
				<div class="xmtitle ">
					我的测评
				</div>
			</div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/index')">
				<div class="dibumenu">
					 <img src="../../assets/img/wd.png" >
				</div>
				<div class="xmtitle ">
					我的
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import {getrwsm,getques,getquesa } from '../../api/baseset'

  export default {
      data() {
        return {
          taskId:'',
          plainwz:{
            title:'',
            explain:'',
            kszt:''
          },
          dtstate:0,
          ms:5

        }
      },
      mounted() {
         this.taskId = this.$route.params.id;

        if(localStorage.getItem('profileData')){
                   const data = JSON.parse(localStorage.getItem('profileData'))

                  this.plainwz.title = data.title
                  this.plainwz.explain = data.explain
                  this.getdataa(data.lbid,data.rwid)
        }
        if(localStorage.getItem('rw_data')){
                   const rwdata = JSON.parse(localStorage.getItem('rw_data'))
                    this.plainwz.kszt = rwdata.rwzt

        }
      },
      components: {

        },
      methods: {

        getdata(id){

          this.loading = true
          let parm = {taskId:id}
            getrwsm(parm)
             .then(res => {

               this.loading = false
               if (res.code != 200) {
                 this.$message({
                   type: 'info',
                   message: res.msg
                 })
               } else {

               }
             })
             .catch(err => {
               this.loading = false
               this.$message.error('数据加载失败，请稍后再试！')
             })

        },
        getdataa(id,rwid){

          this.loading = true
           let parm = {gaugeId:id,taskId:rwid}

            getquesa(parm)
             .then(res => {
              this.loading = false
               if (res.code != 200) {
                 this.$message({
                   type: 'info',
                   message: res.msg
                 })
               } else {


                  if(res.data[0].isAnswer == false ){

                  }else{
                      this.dtstate = 1;
                      const intervalIdaaa = setInterval(() => {

                        if(this.ms < 1){
                          clearInterval(intervalIdaaa);
                           this.$router.push("/user/cprw/");
                        }else{
                          this.ms--;
                        }

                        // this.second = seconds;
                      }, 1000);
                  }
                 // this.formdata2 = res.data.vmodel



               }
             })
             .catch(err => {
               this.loading = false
               this.$message.error('数据加载失败，请稍后再试！')
             })

        },
        // 搜索事件
        search() {
          this.formInline.page = 1
          this.formInline.limit = 10
          this.getdata(this.formInline)
        },
        // 重置搜索
        formReset() {
          this.formInline.key = '';
        },
        shouli() {

        },
        chuli() {
          this.dialogVisible = true;
        },
        tz(url){

          this.$router.push(url);
        },
        fh(){
         window.history.go(-1);
        },
        handleEvent(value) {

            },
      }
    }
  </script>

<style scoped>
  	body{
  			background-color: #EFEFF4;
  		}

  		.footer {
  		  position: fixed ;
  		  bottom: 0;
  		  width: 100%;
  		  height: 60px; /* 底部栏的高度 */

  		  background-color: white;
  		  display: flex;
  		  border-top: solid 1px #E6EAEC;
       /* border: solid 1px red; */
        margin-left:  0 !important;
  		}
  		.item_list_menu{
  			/* border: solid 1px red; */
  			text-align: center;
  		}
  		.dibumenu{
  			width: 100%;
  			text-align: center;
  			padding-top: 3px;
  		}
  		.dibumenu img{
  			width: 24px;
  			height: 24px;
  		}
  		.xmtitle{
  			text-align: center;
  			font-size: 12px;
  			color: #666666;
  		}
  		.xmtitle_active{
  			color: #00DDA3;
  		}



    .userliebiao{
    	display: flex;
    	font-size: 14px;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;
    }
    .userinfo{
    	text-align: right;
    }
    .dibuxian{
    	width: 100%;
    	height: 90px;
    }
    .yjt img{
    	width: 24px;
    	height: 24px;
    }

    .bfwrxx_left{
    	text-align: left !important;
    	font-size: 18px  !important;
    	line-height: 40px !important;
    	padding-left: 2% !important;
    }
    .qrbc{
    	width:40%;
    	height: 30px;
    	margin: 0 auto;
    	text-align: center;
    	line-height: 30px;
    	color: white;
    	border-radius: 5px 5px 5px 5px;
    	background-color: #00DDA3;
    	margin-top: 15px;
    	margin-bottom: 10px;
    }
    .uinfo{
    	width: 100%;
    	height: auto;
    	/* padding-top: 5px;
    	padding-bottom: 5px; */
    	background-color: white;
      font-size: 12px;
    }
    .uinfo_1{
    	width: 88%;
    	height: auto;
    	margin: 0 auto;
    }
    .bkx{
      width: 100%;
      height: 80px;
    }
    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }

    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 2.5rem;
    	line-height:2.5rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }
    .uinfo_1{
    	width: 90%;
    	height: auto;
    	margin: 0 auto;
    }
    .userliebiao{
    	display: flex;
    	font-size: 12px;
    	height: auto;

    	background-color: white;
    }

    .form-control{
    	 border: none !important;
    	font-size: 12px;
    	height: 3rem;

    }
    .form-control:focus {
        outline: none;
        border-color: #ccc;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .xingxing{
    	color:red;
    }
    .rwbt{
      width: 100%;
      height: auto;

      background-color: white;
      margin-top: 15px;
       box-shadow: 2px 2px 2px 2px #ccc,-2px -2px 2px 2px #ccc;
    }
    .rwbtaaa{
       box-shadow: 0 0 0 0 ;
    }
    .bwbt_1{
      width: 92%;
      height: 3rem;
      margin: 0 auto;
      line-height: 3rem;
      /* border: solid 1px #ccc; */
     /* padding-top: -10px; */
      font-size:14px;
      color: black;
      font-weight: bold;

    }
    .bwbt_1::before {
        content: "   ";
        display:inline-block;
        position: relative;
        width: 5px;
          /* background-color: red; */
        border-left:solid 5px #00DDA3;
        height: 25px;
        padding-left: 7px;
        top:5px;
      }
      .bwbt_11{
        width: 92%;
        height: 3rem;
        margin: 0 auto;
        line-height: 3rem;

        font-size:14px;
        color: black;
        font-weight: bold;

      }
      .bwbt_11::before{
        content: "   ";
        display:inline-block;
        position: relative;
        width: 5px;
          /* background-color: red; */
        border-left:solid 5px #FF6712;
        height: 25px;
        padding-left: 7px;
        top:5px;
      }
      .xxjs{
        width: 100%;
        height: auto;
        padding-top: 1px;
        padding-bottom: 15px;
        background-color: white;
        font-size: 14px;
      }
      .xxjs_sm{
        width: 90%;
        margin: 0 auto;
        line-height: 22px;
      }
      .xxjs_xq{
        width: 90%;
        margin: 0 auto;
        line-height: 24px;
        margin-top: 20px;
      }
      .dtan{
        height: 30px;
        line-height: 30px;
        margin: 0 auto;
        text-align: center;
        color: white;
        font-size: 14px;
        background-color: #00DDA3;
        border-radius: 10px 10px 10px 10px;
        width: 50%;
        margin-top: 40px;
      }
      .wks{
        background-color: #ccc;
      }
      .wksda{
        width: 80% !important;
      }
      .qrfh{
        color: #00DDA3;
        width: 100%;
        margin-top: 15px;
        text-align: center;
        font-weight: bold;
      }
</style>



// WEBPACK FOOTER //
// src/views/user/cpjsa.vue